import { Paper } from "@mui/material";
import NavBar from "./components/Nav/NavBar";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import theme, { gradients, colors } from "./Theme/theme";
import { ThemeProvider } from "@mui/material/styles";
import Contact from "./Pages/Contact";
import Footer from "./Pages/Footer";
import CredibilityBar from "./components/Home/CredibilityBar";
import useMediaQuery from "@mui/material/useMediaQuery";
import GradientTransition from "./components/Transitions/GradientTransition";
import { ParallaxProvider } from "react-scroll-parallax";

const skipLinkStyles = {
	position: "absolute",
	left: "-9999px",
	top: "auto",
	width: "1px",
	height: "1px",
	overflow: "hidden",
	zIndex: 9999,
	":focus": {
		left: "16px",
		top: "16px",
		width: "auto",
		height: "auto",
		padding: "8px 16px",
		backgroundColor: "#0a2448",
		color: "#FAD461",
		fontWeight: 700,
		fontSize: "0.9rem",
		textDecoration: "none",
		outline: "3px solid #FAD461",
	},
};

function App() {
	const xl = useMediaQuery(theme.breakpoints.up("xl"));

	return (
		<ThemeProvider theme={theme}>
			<ParallaxProvider>
				<a href="#main-content" style={skipLinkStyles}>
					Skip to main content
				</a>
				<Paper
					sx={{
						mr: xl ? 40 : 0,
						ml: xl ? 40 : 0,
						background: gradients.primary.topDownDeep,
						minHeight: "100vh",
						position: "relative",
						overflow: "hidden",
					}}
				>
					<NavBar />
					<div id="main-content">
					<Home />
					<Services />
					<Contact />
					<About />
					{/* <CredibilityBar /> */}
					<Footer />
					</div>
				</Paper>
			</ParallaxProvider>
		</ThemeProvider>
	);
}

export default App;
